const e = {
  labelXs: {
    fontSize: "xs",
    fontWeight: "medium",
    lineHeight: "5",
    letterSpacing: "normal"
  },
  labelSm: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "5",
    letterSpacing: "normal"
  },
  labelMd: {
    fontSize: "xl",
    fontWeight: "medium",
    lineHeight: "6",
    letterSpacing: "normal"
  },
  subtitleSm: {
    fontSize: "sm",
    fontWeight: "normal",
    lineHeight: "6",
    letterSpacing: "normal"
  },
  subtitleMd: {
    fontSize: "md",
    fontWeight: "normal",
    lineHeight: "6",
    letterSpacing: "normal"
  },
  bodySm: {
    fontSize: "sm",
    fontWeight: "normal",
    lineHeight: "6",
    letterSpacing: "normal"
  },
  bodyMd: {
    fontSize: "md",
    fontWeight: "normal",
    lineHeight: "6",
    letterSpacing: "normal"
  },
  linkSm: {
    fontSize: "sm",
    fontWeight: "medium",
    lineHeight: "5",
    letterSpacing: "normal"
  },
  linkMd: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "6",
    letterSpacing: "normal"
  },
  caption: {
    fontSize: "sm",
    fontWeight: "light",
    lineHeight: "5",
    letterSpacing: "normal"
  },
  button: {
    fontSize: "md",
    fontWeight: "medium",
    lineHeight: "6",
    letterSpacing: "wider"
  },
  tabSm: {
    fontSize: "sm",
    fontWeight: "regular",
    lineHeight: "5",
    letterSpacing: "normal"
  },
  tabMd: {
    fontSize: "xl",
    fontWeight: "regular",
    lineHeight: "7",
    letterSpacing: "normal"
  },
  tabSmBold: {
    fontSize: "sm",
    fontWeight: "bold",
    lineHeight: "5",
    letterSpacing: "normal"
  },
  tabMdBold: {
    fontSize: "xl",
    fontWeight: "bold",
    lineHeight: "7",
    letterSpacing: "normal"
  }
};
export {
  e as textStyles
};
